<template>
  <div class="login">
    <LoginForm
      :loginErr="loginErr"
      :loginErrMessage="loginErrMessage"
      :joinOrg=false
      :redirect="redirectUrl"
    />
    <router-link to="register" class="to-register-link">
      <span class="smaller">First time here? Register</span>
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LoginForm from 'shared/components/LoginForm';

export default {
  name: 'Login',
  components: {
    LoginForm,
  },
  computed: {
    ...mapState({
      loginErr: state => state.users.loginErr,
      loginErrMessage: state => state.users.loginErrMessage,
    }),
    redirectUrl() {
      if (this.$route && this.$route.query) {
        return this.$route.query.redirect;
      }
      return false;
    },
  },
  methods: {
    async callLoginAction() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        await this.$store.dispatch('users/login', {
          email: this.$refs.email.value,
          password: this.$refs.password.value,
        });
        this.$router.push('/');
      }
      this.loading = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.login {
  .smaller {
    font-size: 16px;
    color: darkgrey;
    font-weight: lighter;
    padding-bottom: 40px;
    &:hover {
      font-weight: 450;
    }
  }
  text-align: center;
  main {
    padding-top: 50px;
    .login-form {
      padding: 0px 40px;
      width: 33%;
      min-width: 450px;
      margin-bottom: 20px;
    }
    .logo {
      margin-bottom: 40px;
      padding: 0px 10px 0px;
      max-width: 100%;
    }
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .submit-button {
      background-color: rgb(23, 198, 140);
      color: white;
      &:disabled {
        background-color: gainsboro !important;
      }
    }
    .title {
      text-align: center;
    }
    .error {
      color: red;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue